/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.presence-parent', {
            // use a parent state to cache the dinghies etc.
            parent: 'board.dinghy',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            resolve: {
                currentProfile: ['PrincipalProfile', function(PrincipalProfile) {
                    return PrincipalProfile.identity(false);
                }]
            }
        })
        .state('board.dinghy.presence', {
            parent: 'board.dinghy.presence-parent',
            url: '/presence?fromDate?untilDate',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/presence/presence.html',
                    controller: 'DinghyPresenceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                fromDate: {
                    value: null,
                    squash: true
                },
                untilDate: {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        fromDate: $stateParams.fromDate,
                        untilDate: $stateParams.untilDate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
